/**
 * Lok Sabha -> Assembly Constituency map for Tamil Nadu (39 seats, 234 ACs).
 *
 * Frontend mirror of backend/src/data/ls_to_ac.json. Kept as a module rather
 * than fetched so route guards can resolve a parliamentary seat synchronously
 * (AuthContext.canAccessConstituency runs during render).
 *
 * MUST stay in sync with the backend file - the server expands an MP user's
 * assigned_lok_sabha with the same mapping, and a drift between the two would
 * let the client show a seat the API then refuses, or hide one it would serve.
 */

export const LS_TO_AC = {
  "Tiruvallur": [
    "Gummidipoondi",
    "Ponneri",
    "Thiruvallur",
    "Poonamallee",
    "Avadi",
    "Madavaram"
  ],
  "Chennai North": [
    "Thiruvottiyur",
    "Dr.radhakrishnan nagar",
    "Perambur",
    "Kolathur",
    "Thiru-vi-ka-nagar",
    "Royapuram"
  ],
  "Chennai South": [
    "Virugampakkam",
    "Saidapet",
    "Thiyagarayanagar",
    "Mylapore",
    "Velachery",
    "Shozhinganallur"
  ],
  "Chennai Central": [
    "Villivakkam",
    "Egmore",
    "Harbour",
    "Chepauk-thiruvallikeni",
    "Thousand lights",
    "Anna nagar"
  ],
  "Sriperumbudur": [
    "Maduravoyal",
    "Ambattur",
    "Alandur",
    "Sriperumbudur",
    "Pallavaram",
    "Tambaram"
  ],
  "Kancheepuram": [
    "Chengalpattu",
    "Thiruporur",
    "Cheyyur",
    "Madurantakam",
    "Uthiramerur",
    "Kancheepuram"
  ],
  "Arakkonam": [
    "Tiruttani",
    "Arakkonam",
    "Sholingur",
    "Katpadi",
    "Ranipet",
    "Arcot"
  ],
  "Vellore": [
    "Vellore",
    "Anaikattu",
    "Kilvaithinankuppam",
    "Gudiyattam",
    "Vaniyambadi",
    "Ambur"
  ],
  "Krishnagiri": [
    "Uthangarai",
    "Bargur",
    "Krishnagiri",
    "Veppanahalli",
    "Hosur",
    "Thalli"
  ],
  "Dharmapuri": [
    "Palacodu",
    "Pennagaram",
    "Dharmapuri",
    "Pappireddipatti",
    "Harur",
    "Mettur"
  ],
  "Tiruvannamalai": [
    "Jolarpet",
    "Tiruppattur",
    "Chengam",
    "Tiruvannamalai",
    "Kilpennathur",
    "Kalasapakkam"
  ],
  "Arani": [
    "Polur",
    "Arani",
    "Cheyyar",
    "Vandavasi",
    "Gingee",
    "Mailam"
  ],
  "Viluppuram": [
    "Tindivanam",
    "Vanur",
    "Viluppuram",
    "Vikravandi",
    "Tirukkoyilur",
    "Ulundurpettai"
  ],
  "Kallakurichi": [
    "Rishivandiyam",
    "Sankarapuram",
    "Kallakurichi",
    "Gangavalli",
    "Attur",
    "Yercaud"
  ],
  "Salem": [
    "Omalur",
    "Edappadi",
    "Salem (west)",
    "Salem (north)",
    "Salem (south)",
    "Veerapandi"
  ],
  "Namakkal": [
    "Sankari",
    "Rasipuram",
    "Senthamangalam",
    "Namakkal",
    "Paramathi-velur",
    "Tiruchengodu"
  ],
  "Erode": [
    "Kumarapalayam",
    "Erode (east)",
    "Erode (west)",
    "Modakkurichi",
    "Dharapuram",
    "Kangayam"
  ],
  "Tiruppur": [
    "Perundurai",
    "Bhavani",
    "Anthiyur",
    "Gobichettipalayam",
    "Tiruppur (north)",
    "Tiruppur (south)"
  ],
  "The Nilgiris": [
    "Bhavanisagar",
    "Udhagamandalam",
    "Gudalur",
    "Coonoor",
    "Mettuppalayam",
    "Avanashi"
  ],
  "Coimbatore": [
    "Palladam",
    "Sulur",
    "Kavundampalayam",
    "Coimbatore (north)",
    "Coimbatore (south)",
    "Singanallur"
  ],
  "Pollachi": [
    "Thondamuthur",
    "Kinathukadavu",
    "Pollachi",
    "Valparai",
    "Udumalaipettai",
    "Madathukulam"
  ],
  "Dindigul": [
    "Palani",
    "Oddanchatram",
    "Athoor",
    "Nilakkottai",
    "Natham",
    "Dindigul"
  ],
  "Karur": [
    "Vedasandur",
    "Aravakurichi",
    "Karur",
    "Krishnarayapuram",
    "Manapparai",
    "Viralimalai"
  ],
  "Tiruchirappalli": [
    "Srirangam",
    "Tiruchirappalli (west)",
    "Tiruchirappalli (east)",
    "Thiruverumbur",
    "Gandharvakottai",
    "Pudukkottai"
  ],
  "Perambalur": [
    "Kulithalai",
    "Lalgudi",
    "Manachanallur",
    "Musiri",
    "Thuraiyur",
    "Perambalur"
  ],
  "Cuddalore": [
    "Tittakudi",
    "Vriddhachalam",
    "Neyveli",
    "Panruti",
    "Cuddalore",
    "Kurinjipadi"
  ],
  "Chidambaram": [
    "Kunnam",
    "Ariyalur",
    "Jayankondam",
    "Bhuvanagiri",
    "Chidambaram",
    "Kattumannarkoil"
  ],
  "Mayiladuthurai": [
    "Sirkazhi",
    "Mayiladuthurai",
    "Poompuhar",
    "Thiruvidaimarudur",
    "Kumbakonam",
    "Papanasam"
  ],
  "Nagapattinam": [
    "Nagapattinam",
    "Kilvelur",
    "Vedaranyam",
    "Thiruthuraipoondi",
    "Thiruvarur",
    "Nannilam"
  ],
  "Thanjavur": [
    "Mannargudi",
    "Thiruvaiyaru",
    "Thanjavur",
    "Orathanadu",
    "Pattukkottai",
    "Peravurani"
  ],
  "Sivaganga": [
    "Thirumayam",
    "Alangudi",
    "Karaikudi",
    "Tiruppattur",
    "Sivaganga",
    "Manamadurai"
  ],
  "Madurai": [
    "Melur",
    "Madurai east",
    "Madurai north",
    "Madurai south",
    "Madurai central",
    "Madurai west"
  ],
  "Theni": [
    "Sholavandan",
    "Usilampatti",
    "Andipatti",
    "Periyakulam",
    "Bodinayakanur",
    "Cumbum"
  ],
  "Virudhunagar": [
    "Thiruparankundram",
    "Thirumangalam",
    "Sattur",
    "Sivakasi",
    "Virudhunagar",
    "Aruppukkottai"
  ],
  "Ramanathapuram": [
    "Aranthangi",
    "Tiruchuli",
    "Paramakudi",
    "Tiruvadanai",
    "Ramanathapuram",
    "Mudhukulathur"
  ],
  "Thoothukkudi": [
    "Vilathikulam",
    "Thoothukkudi",
    "Tiruchendur",
    "Srivaikuntam",
    "Ottapidaram",
    "Kovilpatti"
  ],
  "Tenkasi": [
    "Rajapalayam",
    "Srivilliputhur",
    "Sankarankovil",
    "Vasudevanallur",
    "Kadayanallur",
    "Tenkasi"
  ],
  "Tirunelveli": [
    "Alangulam",
    "Tirunelveli",
    "Ambasamudram",
    "Palayamkottai",
    "Nanguneri",
    "Radhapuram"
  ],
  "Kanyakumari": [
    "Kanniyakumari",
    "Nagercoil",
    "Colachal",
    "Padmanabhapuram",
    "Vilavancode",
    "Killiyoor"
  ]
};

// Mirrors backend normalizeConstituencyKey: drop a bracketed reservation
// suffix ("Ottapidaram (SC)") before stripping everything non-alphanumeric,
// so the GeoJSON's "Ottapidaram(SC)" and the roster's "Ottapidaram" agree.
const normalize = (v) =>
  String(v || '')
    .toLowerCase()
    .replace(/\([^)]*\)/g, ' ')
    .replace(/[^a-z0-9]/g, '')
    .trim();

// normalize() cannot collapse a doubled consonant, and both Tamil
// transliterations of this seat occur across the data and in stored user
// records, so the variants are mapped explicitly.
const LS_ALIASES = {
  thoothukudi: 'thoothukkudi',
  tuticorin: 'thoothukkudi',
};

/** Assembly segments of one parliamentary seat. Accepts any known spelling. */
export const childAcsForLokSabha = (ls) => {
  if (!ls) return [];
  const key = normalize(ls);
  const canonical = LS_ALIASES[key] || key;
  const hit = Object.keys(LS_TO_AC).find((k) => {
    const k2 = normalize(k);
    return k2 === key || k2 === canonical;
  });
  return hit ? LS_TO_AC[hit] : [];
};

export const normalizeConstituencyKey = normalize;

export default LS_TO_AC;
